import React from 'react'
import { useIntl } from 'react-intl'
import formatOfferInclusionDescription from 'lib/offer/formatOfferInclusionDescription'
import LineUsdCircleIcon from 'LuxKit/Icons/line/LineUsdCircleIcon'
import LineTagIcon from 'LuxKit/Icons/line/LineTagIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { STANDARD_INCLUSION_TYPE, sortByInclusionPriority, type InclusionType } from './CruiseStandardInclusionList'

export { STANDARD_INCLUSION_TYPE } from './CruiseStandardInclusionList'

interface Props {
  standardInclusions: Array<App.PackageInclusion>
  type?: InclusionType
  allInclusions?: boolean
}

function CruiseStandardInclusionLabel({ standardInclusions, type, allInclusions = false }: Props) {
  const intl = useIntl()
  const [inclusion] = [...standardInclusions
    .filter(({ parentCategory }) =>
      allInclusions || (type != null && parentCategory === type),
    )]
    .sort(sortByInclusionPriority)

  if (!inclusion) return null

  const Icon = inclusion.parentCategory === STANDARD_INCLUSION_TYPE.ONBOARD_CREDIT ? LineUsdCircleIcon : LineTagIcon

  return (
    <BodyTextBlock
      startIcon={<Icon colour="highlight-primary-dark" />}
      weight="bold"
      variant="medium"
      colour="highlight-primary-dark"
    >
      {formatOfferInclusionDescription(inclusion.description, intl)}
    </BodyTextBlock>
  )
}

export default CruiseStandardInclusionLabel
